export const chatbotsPath = () => "/chatbots";
export const chatbotsEditPath = (bot) => `/chatbots/${bot.id}`;
export const chatbotsNewPath = () => "/chatbots/new";
